// from https://github.com/Shopify/liquid/blob/63eb1aac69a31d97e343822b973b3a51941c8ac2/performance/shopify/shop_filter.rb#L100
handleize = function (str) {
  str = String(str).toLowerCase();

  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
  
  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
  }

  str = str.replace(/\W+/g, "-");

  if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
  }

  if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
  }

  return str
};